import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatOnboardingComponent } from './components/chat-onboarding.component';
import { ChatOnboardingService } from './services/chat-onboarding.service';
import { FloatingButtonComponent } from './components/floating-button/floating-button.component';
import { FloatingChatComponent } from './components/floating-chat/floating-chat.component';
import { WelcomeComponent } from './components/messages/welcome/welcome.component';
import { ChecklistComponent } from './components/messages/checklist/checklist.component';
import { StorageService } from '../../services/storage.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
  ],
  declarations: [
    ChatOnboardingComponent, 
    FloatingButtonComponent, 
    FloatingChatComponent, 
    WelcomeComponent, 
    ChecklistComponent],
  exports: [
    ChatOnboardingComponent,
  ],
  providers: [
    ChatOnboardingService,
    StorageService,
  ],
})
export class ChatOnboardingModule { }
